import type { JSX } from 'react';
import { Link } from 'react-router';
import { useBrand } from '../brand/context.js';
import { useI18n } from '../i18n/context.js';

/**
 * Подсказка «первая книга за четыре шага» вместо пустого списка книг (E15-T2).
 *
 * Заменяет собой пустое состояние `/app`: новичку нужен не серый текст
 * «книг нет», а карта пути и кнопка, с которой этот путь начинается.
 */
export function OnboardingGuide({ onStart }: { readonly onStart: () => void }): JSX.Element {
  const { t, locale } = useI18n();
  const brand = useBrand();

  return (
    <section aria-labelledby="onboarding-title" className="kitup-card mt-8 grid gap-6 p-6 sm:p-8">
      <div className="grid gap-2">
        <h2 id="onboarding-title" className="text-xl font-semibold">
          {t.onboarding.title}
        </h2>
        <p className="max-w-prose text-sm text-[var(--kitup-color-muted)]">{t.books.empty}</p>
      </div>

      <ol className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {t.onboarding.steps.map((step, index) => (
          <li key={step.title} className="grid content-start gap-2">
            <span className="kitup-step-number" aria-hidden="true">
              {(index + 1).toLocaleString(locale)}
            </span>
            <h3 className="font-semibold">{step.title}</h3>
            <p className="text-sm text-[var(--kitup-color-muted)]">{step.text}</p>
          </li>
        ))}
      </ol>

      <div className="flex flex-wrap gap-3">
        <button type="button" className="kitup-primary-button" onClick={onStart}>
          {t.onboarding.start}
        </button>
        <Link
          to={brand.onboardingExamplePath}
          state={{ fromApp: true }}
          className="kitup-secondary-button"
        >
          {t.onboarding.demo}
        </Link>
      </div>
    </section>
  );
}
